<template>
  <el-submenu
    :class="(data, $route, activeIndex | supClass)"
    :index="data.uri || ''"
  >
    <template slot="title">
      <span class="active-color"></span>
      <i :class="data.iconClass" />
      <span>
        {{ data.name }}
      </span>
    </template>
    <el-menu-item
      :index="child.uri"
      :key="child.id"
      v-for="child in data.children"
    >
      <span slot="title" :class="{ active: child.uri === activeIndex }">
        {{ child.name }}
      </span>
    </el-menu-item>
  </el-submenu>
</template>

<script>
import MenuItem from "./menu-item";
import { mapState } from "vuex";

export default {
  name: "SubMenu",
  filters: {
    supClass(routeObj, $route, activeIndex) {
      const menuRoute = routeObj.route;
      if (routeObj.children) {
        const childRoutes = routeObj.children.map((item) => item.route);
        const childActive = childRoutes.some((item) => {
          return $route.path.includes(item) || item === activeIndex;
        });
        return childActive ? "sup-active" : "";
      }
      return $route.path === menuRoute ? "sup-active" : "";
    },
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      activeIndex: "",
      supClass: "",
    };
  },
  computed: {
    ...mapState(["tipNum"]),
  },
  mounted() {
    this.activeIndex =
      this.$route.meta[this.$route.meta.length - 1].activeRoute;
  },
  watch: {
    $route(val) {
      this.activeIndex = val.meta[val.meta.length - 1].activeRoute;
    },
  },
  components: { MenuItem },
};
</script>

<style scoped>
.active {
  color: #1890ff;
}
.sup-active .active-color {
  display: inline-block;
  position: relative;
  left: -10px;
  width: 3px;
  height: 22px;
  background: #1890ff;
}
</style>
